const ACCEPTED_IMAGE_TYPES = new Set([
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/webp',
  'image/heic',
  'image/heif',
]);

const IMAGE_FILE_NAME = /\.(jpe?g|png|webp|heic|heif)$/i;

export const isAcceptedStudentPhotoFile = (file: File): boolean => {
  const mimeType = file.type.trim().toLowerCase();

  if (ACCEPTED_IMAGE_TYPES.has(mimeType)) {
    return true;
  }

  return mimeType === '' && IMAGE_FILE_NAME.test(file.name);
};
